/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".editingInput_83049000{border:0px;outline:none;width:100%}.editingInput_83049000::-ms-clear{display:none}.editingContainer_83049000{margin:4px}\n"}]);
export const editingInput = "editingInput_83049000";
export const editingContainer = "editingContainer_83049000";